module.exports = __webpack_public_path__ + "static/media/Cecil_Cheng_Resume.fc956dc8.pdf";